/* eslint-disable */
import { gql } from 'apollo-boost'
import apolloClient from '../apollo/config'

export async function getAppointments() {
  return apolloClient
    .query({
      query: gql`
        query {
          appointments(first: 100) {
            edges {
              node {
                id
                therapist {
                  id
                  name
                  surname
                }
                student {
                  id
                  firstname
                  lastname
                }
                attendee {
                  edges {
                    node {
                      id
                      name
                      surname
                    }
                  }
                }
                createdBy {
                  id
                  firstName
                  lastName
                }
                appointmentStatus {
                  id
                  appointmentStatus
                }
                location {
                  id
                  location
                }
                purposeAssignment
                note
                title
                start
                end
                isApproved
              }
            }
          }
        }
      `,
      fetchPolicy: 'network-only',
    })
    .then(res => res)
    .catch(err => err)
}

export async function deleteAppointment(payload) {
  console.log(payload)
  return apolloClient
    .mutate({
      mutation: gql`
        mutation($id: ID!) {
          DeleteAppointment(id: $id) {
            success
          }
        }
      `,
      variables: {
        id: payload.object.id,
      },
      fetchPolicy: 'network-only',
    })
    .then(response => response)
    .catch(err => err)
}
